import { Box } from '@mui/material';
import { AutojobsChart } from 'src/modules/dashboard/components/autojobs/autojobsChart';

export const AutojobsWidget = () => (
  <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
    <AutojobsChart />
  </Box>
);
